import { createQueryKeys } from '@lukemorales/query-key-factory';

/** 로그인한 스태프 사용자 React Query 캐시·뮤테이션 키 팩토리. */
export const userKeys = createQueryKeys('user', {
  profile: null,
  changePassword: null,
});
